module.exports = __webpack_public_path__ + "img/1504731378.341b926b.jpg";